module.exports = {

  /* 测试号 https://mp.weixin.qq.com/debug/cgi-bin/sandbox?t=sandbox/login */
  // userInfo_url: "http://192.168.0.125:8080/#/userInfo",
  // API_URL: "http://192.168.0.125:3038",

  /* 线上 */
  // userInfo_url: "https://mp.weixin.bboycc.cn/#/userInfo", //微信登录后跳转到=》用户个人中心
  userInfo_url: "https://mp.weixin.hyxmp.com/#/userInfo", //微信登录后跳转到=》用户个人中心
  API_URL: "https://shzskx-api.bboycc.cn", //接口地址
};